import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import ContactForm from './ContactForm';
import { useServices } from '../../contexts/ServiceContext';
import { Contact } from 'common/model';

export default function EditContact() {
   const { id } = useParams();
   const { t } = useTranslation();

   const { contactService } = useServices();

   const navigate = useNavigate();
   const [contact, setContact] = useState(undefined);
   const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | undefined>(undefined);

   useEffect(() => {
      const fetchContact = async () => {
         try {
            setLoading(true);
            const contact = await contactService.getById(id as string);
            setContact(contact);
            setLoading(false);
         } catch (err) {
            //  setError("Failed to load contact information.");
            setLoading(false);
         }
      };

      if (id) fetchContact();
   }, [id]);

   const handleSave = async (formData) => {
      const contactModel = {
         Id: formData.id,
         FacilitatorId: formData.facilitatorId,
         FirstName: formData.firstName,
         LastName: formData.lastName,
         Email: formData.email,
         JobTitle: formData.jobTitle,
         CompanyName: formData.companyName,
         CompanyWebsite: formData.companyWebsite,
         LinkedInProfile: formData.linkedinProfile,
         IntroductionParagraph: formData.introduction,
         CreatedAt: formData.createdAt || new Date().toISOString(),
         UpdatedAt: new Date().toISOString(),
      };
      try {

         await contactService.edit(contactModel);
      } catch (err) {
         setError(t("contact_save_failed"));
         return;
      }
   }

   if (loading) return <div className="p-6">Loading...</div>;

   return (
      <ContactForm contact={contact} onSubmit={handleSave} error={error}/>
   );
}